/**
 * Multi-field registration + terms + nested legal modal sheet regions.
 * @see ../atomicRules.ts
 */
import { Platform, StyleSheet } from 'react-native';
import { appTheme } from '../../appTheme';
import type { ThemeColors } from '../../store';

export function createRegistrationFormSheetStyles(c: ThemeColors) {
  return StyleSheet.create({
    countryCodeText: {
      ...appTheme.typography.body,
      fontWeight: '600',
      color: c.text,
      letterSpacing: 0.2,
      lineHeight: 21,
      textAlign: 'center',
      marginTop: Platform.select({ ios: -3, android: -2, default: 0 }),
    },
    tcRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: appTheme.spacing.lg,
      gap: appTheme.spacing.sm,
      paddingHorizontal: appTheme.spacing.md,
    },
    checkbox: {
      width: appTheme.spacing.lg + appTheme.spacing.xs,
      height: appTheme.spacing.lg + appTheme.spacing.xs,
      borderWidth: appTheme.borderWidth.thick,
      borderRadius: appTheme.borderRadius.xs,
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: c.border,
    },
    checkboxChecked: {
      backgroundColor: c.primary,
      borderColor: c.primary,
    },
    checkboxInvalid: {
      borderColor: c.error,
    },
    tcTextBlock: {
      flexShrink: 1,
      flexGrow: 0,
      minWidth: 0,
    },
    tcText: {
      fontSize: 12,
      lineHeight: 16,
      fontWeight: '400',
      color: c.textSecondary,
    },
    tcLink: {
      fontSize: 12,
      lineHeight: 16,
      fontWeight: '600',
      color: c.primary,
      textDecorationLine: 'underline',
    },
    loginRow: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: appTheme.spacing.xs,
    },
    loginText: { ...appTheme.typography.bodySmall, color: c.textSecondary },
    loginLink: { ...appTheme.typography.bodyMedium, color: c.primary },
    /** Tighter terms row on MainScreen bottom-sheet register form. */
    tcRowMainScreen: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: appTheme.spacing.md,
      gap: appTheme.spacing.sm,
      paddingHorizontal: 0,
    },
    /** Terms sheet body scroll (used inside `BottomSheetPopup`). */
    modalContent: {
      paddingHorizontal: appTheme.spacing.md,
      paddingVertical: appTheme.spacing.md,
    },
    modalText: {
      ...appTheme.typography.bodySmall,
      lineHeight: (appTheme.typography.bodySmall.lineHeight ?? 18) + appTheme.spacing.xs,
      color: c.textSecondary,
    },
    /** Prefer `BottomSheetPopupFooter` for action rows — it pairs with the sheet safe-area bar. */
    modalFooter: {
      flexDirection: 'row',
      padding: appTheme.spacing.md,
      gap: appTheme.spacing.md,
      borderTopWidth: appTheme.borderWidth.default,
      borderTopColor: c.border,
    },
    modalFooterBtnOuter: { flex: 1 },
  });
}

export type RegistrationFormSheetStyles = ReturnType<typeof createRegistrationFormSheetStyles>;
